import { createSelector } from 'reselect';

import { State } from 'types';
import { UIState } from './types';

export const selectUI = (state: State): UIState => state.ui;

export const selectOddFormat = createSelector(selectUI, ui => ui.oddFormat);
export const selectIsSidebarOpen = createSelector(
    selectUI,
    ui => ui.isSidebarOpen
);
export const selectOddsStatisticView = createSelector(
    selectUI,
    ui => ui.oddsStatistic
);

export const selectSidebarView = createSelector(selectUI, ui => ui.sidebarView);
export const selectFavoriteCount = createSelector(
    selectUI,
    ui => ui.favoriteCount
);

export const selectUpcomingFavoriteCount = createSelector(
    selectFavoriteCount,
    favoriteCount => favoriteCount.upcoming
);

export const selectOutrightsFavoriteCount = createSelector(
    selectFavoriteCount,
    favoriteCount => favoriteCount.outrights
);

export const selectAllFavoriteCount = createSelector(
    selectUpcomingFavoriteCount,
    selectOutrightsFavoriteCount,
    (upcomingCount, outrightsCount) => {
        if (upcomingCount === null || outrightsCount === null) {
            return null;
        }

        return upcomingCount + outrightsCount;
    }
);

export const selectIsOddHistoryEnabled = createSelector(
    selectUI,
    ui => ui.isOddHistoryEnabled
);

export const selectIsFilterOpened = createSelector(
    selectUI,
    ui => ui.isFilterOpened
);

export const selectActiveMobileCountryKey = createSelector(
    selectUI,
    ui => ui.activeMobileCountryKey
);

export const selectIsOddsChangeModalShown = createSelector(selectUI, ui =>
    ui.get('isOddsChangeModalShown')
);
